import 'assets/styles/compliance.scss';

import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useStore } from 'hooks';
import * as config from "../../config/constants";

const RegulationDocuments = (props) => {
  const [businessProcessesData, setBusinessProcessesData] = useState();
  const [businessProcessesNext, setBusinessProcessesNext] = useState('');
  const [businessProcessesCount, setBusinessProcessesCount] = useState(0);
  const [businessProcessesDisplayCount, setBusinessProcessesDisplayCount] = useState(0);
  const [docRegulationUnderControlCount, setDocRegulationUnderControlCount] = useState(0);
  const [businessProcessesLoading, setBusinessProcessesLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const store = useStore();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const numRecordPage = config.pageSize;
  const { customProp } = props;

    const getDocRegulationPercentage = async (activeBusinessId) => {
    try {
      const { data } = await store.api.getRegulationPercentage(activeBusinessId);
      return data;
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    }
  };

  const getBusinessProcesses = async () => {
    try {
      setIsLoading(true);
      const { data } = await store.api.getDocumentRegulations(customProp);
      setBusinessProcessesData(data);
      setBusinessProcessesNext(data.next);
      setBusinessProcessesCount(data.count);
      data.count > numRecordPage
        ? setBusinessProcessesDisplayCount(numRecordPage)
        : setBusinessProcessesDisplayCount(data.count);

      var dict ={};
      const promises = data.map(async (process, i) => {
         dict[process.id] =  await getDocRegulationPercentage(process.id);
      });
      await Promise.all(promises);
      setDocRegulationUnderControlCount(dict);
    } catch (error) {
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getNextBusinessProcesses = async () => {
    try {
      setBusinessProcessesLoading(true);
      const { data } = await store.api.getNextDataWithURL(businessProcessesNext);
      let addNewDomains = businessProcessesData;
      setBusinessProcessesNext(data.next);
      setBusinessProcessesData(undefined);
      const arrayLength = data.results.length;
      data.results.map((process, i) => {
        addNewDomains.push(process);
        if (arrayLength == i + 1) {
          setBusinessProcessesData(addNewDomains);
          setBusinessProcessesLoading(false);
          setBusinessProcessesDisplayCount(businessProcessesDisplayCount + arrayLength);
        }
      });
    } catch (error) {
      setBusinessProcessesLoading(false);
      if (error.response && error?.response?.status === 403) {
        enqueueSnackbar('You do not have permission to view this data', {
          variant: 'error',
        });
      } else {
        enqueueSnackbar('An error occurred, please contact support', {
          variant: 'error',
        });
      }
    } finally {
      setBusinessProcessesLoading(false);
    }
  };

  useEffect(() => {
    getBusinessProcesses();
  }, [props.location.pathname]);

  const navigateToBusinessProcess = (processId) => {
    const path = '/micro-regulatory-list?regulation=' + processId;
    history.push(path);
  };

  return (
    <section className={'compliance-container'}>
      <div className="back-nav" onClick={() => history.push('/home')}>
        Home
      </div>
      <div className="header-icon"></div>
      <h4>{customProp === 'regulation' ? 'Real-time Reg Compliance Framework': 'Real-time Ops Controls Framework' } </h4>

      <ul className="categories-list">
        <li key="count" style={{ backgroundColor: '#f4f5f7' }}>
          <span>
            Displaying {businessProcessesDisplayCount} of {businessProcessesCount} Regulation
            Documents
          </span>
        </li>

        {businessProcessesData !== undefined &&
          businessProcessesData.map((process, i) => {
            const processId = process.id;
            let percentage = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].percentage : 0;
            const applicable = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].applicable: 0;
            const validation_passed = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].validation_passed: 0;
            const evidence_passed = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].evidence_passed: 0;
            const total = docRegulationUnderControlCount[process.id] ? docRegulationUnderControlCount[process.id].total: 0;
            const zIndexgreen = evidence_passed >= validation_passed ? 2 : 1;
            const zIndexlight = evidence_passed >= validation_passed ? 1 : 2 ;
            const percentageEvidence = (Math.round(evidence_passed * 100) / applicable) * 1.10;
            if (evidence_passed > validation_passed) {
              percentage = evidence_passed/applicable;
            }
            return (
              <li key={i} onClick={() => navigateToBusinessProcess(processId)}>
                <span>{processId}</span>
                <span className="title-spacing">{process.name}</span>
                <div className="status-text">
                  <span className="last-updated">
                     Effective Date: {process.effective_date}
                  </span>
                </div>
               <div className="applicable-percentage">   {validation_passed}/{evidence_passed}/{applicable}/{total}</div>
                <div className="status red-percentage">
                  <div
                  className="green"
                  style={{ width: `${percentage}%`, zIndex:`${zIndexgreen}`}}>
                  </div>
                  <div
                  className="lightgreen"
                  style={{ width: `${percentageEvidence}%`, zIndex:`${zIndexlight}` }}>
                  </div>

                </div>
              </li>
            );
          })}
        {businessProcessesCount > 10 && (
          <li className="get-next" key="next" onClick={() => getNextBusinessProcesses()}>
            <span>{businessProcessesLoading ? 'Loading...' :  'Load ' + numRecordPage.toString() + ' more'}</span>
          </li>
        )}
      </ul>
    </section>
  );
};

RegulationDocuments.defaultProps = {};

export default RegulationDocuments;
